<div class="create-survey-wrapper w-full hidden sm:flex">
  <div class="form-wrapper w-full">

    <div class="py-0 px-0 sm:py-10 sm:px-8 w-full">

      <div class="general-information-content">
        Send to
      </div>
      <hr class="w-full separator">

      <div class="general-information-form-wrapper w-full flex flex-col items-center">
        <div class="general-information-input-section w-full sm:w-[90%]">
          <app-filter-dropdown
            (checkForErrors)="checkForErrors($event)"
            [enableAllSelection]="true"
            [enableClearSelection]="true"
            [enableMultiple]="true"
            [error]="errorMessages['roles']"
            [loading]="rolesLoading"
            [options]="rolesOptions"
            [parentFormGroup]="form"
            controlName="roles"
            label="Choose Roles"
            placeholder="Select all that apply"
            type="small"></app-filter-dropdown>
        </div>
        <div
          class="general-information-description-input-section w-full sm:w-[90%] flex-col sm:flex-row flex justify-between">
          <div *ngIf="!onlySuperAdminSelected"
               class="w-full sm:w-[48%]">
            <app-filter-dropdown
              (checkForErrors)="checkForErrors($event)"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [enableAllSelection]="true"
              [error]="errorMessages['clientIds']"
              [loading]="clinicsLoading"
              [options]="clinicsOptions"
              [hasNext]="clinicsHasNext"
              [enableSearch]="true"
              [filterControlName]="'clientSearch'"
              [searchPlaceholder]="'Search'"
              (onNextPage)="fetchClinicsNextPageOptions()"
              [parentFormGroup]="form"
              controlName="clientIds"
              label="Choose Organizations"
              placeholder="Select all that apply"
              type="small"></app-filter-dropdown>
          </div>
          <div *ngIf="!onlySuperAdminSelected"
               class="w-full sm:w-[48%]">
            <app-filter-dropdown
              (checkForErrors)="checkForErrors($event)"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [hasNext]="groupHasNext"
              [searchPlaceholder]="'Search'"
              [enableSearch]="true"
              [filterControlName]="'groupSearch'"
              [enableAllSelection]="true"
              (onNextPage)="fetchGroupsNextPageOptions()"
              [error]="errorMessages['groupIds']"
              [loading]="groupsLoading"
              [options]="groupsOptions"
              [parentFormGroup]="form"
              controlName="groupIds"
              label="Choose Groups"
              placeholder="Select all that apply"
              type="small"></app-filter-dropdown>
          </div>
        </div>
        <div class="flex w-full justify-start more-filter-content">
          More Filters
        </div>
        <hr class="w-full separator">
        <div
          class="general-information-description-input-section w-full sm:w-[90%] flex-col sm:flex-row flex justify-between">
          <div *ngIf="!onlySuperAdminSelected"
               class="w-full sm:w-[48%]">
            <app-filter-dropdown
              (checkForErrors)="checkForErrors($event)"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [enableAllSelection]="true"
              [error]="errorMessages['groupStatus']"
              [loading]="groupStatusLoading"
              [options]="groupStatusOptions"
              [parentFormGroup]="form"
              controlName="groupStatus"
              label="Group Status"

              placeholder="Select all that apply"
              type="small"></app-filter-dropdown>
          </div>
          <div class="w-full sm:w-[48%]">
            <app-filter-dropdown
              (checkForErrors)="checkForErrors($event)"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [enableAllSelection]="true"
              [error]="errorMessages['gender']"
              [loading]="genderLoading"
              [options]="genderOptions"
              [parentFormGroup]="form"
              controlName="gender"
              label="Choose Gender"
              placeholder="Select all that apply"
              type="small"></app-filter-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="py-0 px-0 sm:py-10 sm:px-8 w-full">
      <div class="general-information-content">
        Schedule
      </div>
      <hr class="w-full separator">
      <div class="schedule-form-wrapper w-full flex justify-center">
        <div
          class="w-full sm:w-[90%] flex flex-col md:flex-row justify-between">
          <div class="schedule-input-section w-full md:w-[45%] ">
            <app-dropdown
              (checkForErrors)="checkForErrors($event)"
              [enableClearSelection]="true"
              [error]="errorMessages['scheduleAccordingTo']"
              [loading]="scheduleAccordingToLoading"
              [options]="scheduleAccordingToOptions"
              [parentFormGroup]="form"
              controlName="scheduleAccordingTo"
              label="Schedule According to"
              placeholder="Select one"
              type="small"/>
          </div>
          <div *ngIf="form.controls['scheduleAccordingTo'].value === 1"
               class="schedule-input-section w-full md:w-[50%]">
            <app-dropdown
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['session']"
              [loading]="sessionLoading"
              [options]="sessionDropDownOptions"
              [parentFormGroup]="form"
              controlName="session"
              label="Session"
              placeholder="Select one"
              type="small"/>
          </div>
          <div *ngIf="form.controls['scheduleAccordingTo'].value === 2"
               class="general-information-input-section w-full md:w-[50%] flex-col md:flex-row flex justify-between">
            <div class="w-full md:w-[48%]">
              <app-date-picker
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['activeFrom']"
                [parentFormGroup]="form"
                [min]="todaysDate"
                controlName="activeFrom"
                label="From"
                placeholder="From"
                type="small"></app-date-picker>
            </div>
            <div class="w-full md:w-[48%]">
              <app-date-picker
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['activeTo']"
                [parentFormGroup]="form"
                [min]="form.value.activeFrom ? form.value.activeFrom : todaysDate"
                controlName="activeTo"
                label="To"
                placeholder="To"
                type="small"></app-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="w-full separator">
    <div
      class="schedule-form-wrapper md:flex-row flex-col w-full flex md:justify-between justify-center">
      <div class="md:w-[50%] w-full flex justify-start">
        <div class="w-full md:w-[30%] flex justify-start">
          <app-primary-button
            (click)="backButtonClicked()"
            class="w-full"
            type="small">
            Back
          </app-primary-button>
        </div>
      </div>
      <div
        class="md:flex-row flex-col md:w-[50%] w-full flex md:justify-end justify-center">
        <div
          class="w-full md:w-[30%] flex justify-end md:ml-[1rem] ml-0 md:mt-0 mt-[1rem]">
          <app-primary-button
            (handleClick)="saveButtonClicked(false)"
            class="w-full"
            type="small"
          >
            Save
          </app-primary-button>
        </div>
        <div
          class="w-full md:w-[40%] lg:w-[30%] flex justify-end md:ml-[1rem] ml-0 md:mt-0 mt-[1rem]">
          <app-primary-button
            (handleClick)="saveButtonClicked(true)"
            class="w-full"
            type="small"
          >
            <div class="add-user flex flex-row justify-center items-center space-x-[1rem]">
              <app-icon
                [svgIcon]="'send-invite'"
                class="icon small"
              >
              </app-icon>
              <span>Publish</span>
            </div>
          </app-primary-button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="flex sm:hidden">
  <app-screen-size-alert [hyperLinkText]="'Go Back To Manage Questionnaires'"
                         navigationLink="/stanford-admin/questionnaires/manage-questionnaires"></app-screen-size-alert>
</div>
